module.exports = __webpack_public_path__ + "static/media/PS_photos.53ec8948.png";